<template>
    <div v-if="payout">
        ID: {{ payout.id }} <br />
        Пользователь: {{ payout.user.fullname }} <br />
        Сумма: {{ payout.amount }} <br />
        Адрес: {{ payout.address }} <br />
        Статус: {{ payout.status.label }} <br />
        Дата: {{ payout.created_at }} <br />

        <br />
        <div v-if="payout.status.id === 0" style="display: flex">
            <button @click="setPaid" class="btn">
                Выплачено
            </button>
            <button @click="setDeclined" style="margin-left: 15px" class="btn">
                Отказать
            </button>
        </div>
    </div>
</template>

<script>
import { api } from "@/updated/modules/admin/pages/forex-finances/services";

export default {
    name: "AccountPayoutPage",
    data() {
        return {
            payout: null
        };
    },
    created() {
        api.getPayout(this.$route.params.id).then(data => {
            this.payout = data.data;
        });
    },
    methods: {
        setPaid() {
            api.setPaidStatus(this.$route.params.id).then(data => {
                this.payout = data.data;
                this.$notify({ type: "success", title: "Статус изменён на: выплачено" });
            });
        },
        setDeclined() {
            this.openModal("ContractDecline", {
                btnText: "Отправить"
            }).then(reason => {
                api.setDeclinedStatus(this.$route.params.id, { reason: reason })
                    .then(data => {
                        this.payout = data.data;
                        this.notify({ type: "success", title: "Заявка на выплату отклонена" });
                    })
                    .catch(() => {
                        this.notify({ type: "error", title: "Ошибка при отклонении" });
                    });
            });
        }
    }
};
</script>

<style scoped></style>
